import { incidentsSlice } from './incidents.slice.ts';

export const { resetIncidents } = incidentsSlice.actions;
